import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { NgForm, NgModel } from '@angular/forms'
import { AnoSafra } from 'src/app/classes/AnoSafra'
import { Cultura } from 'src/app/classes/Cultura'
import { Safra } from 'src/app/classes/Safra'
import { SafraService } from 'src/app/services/safra.service'
import { UiModalComponent } from 'src/app/theme/shared/components/modal/ui-modal/ui-modal.component'
import { UtilsService } from 'src/app/utils/utils.service'

@Component({
  selector: 'app-config-projeto-cultura',
  templateUrl: './config-projeto-cultura.component.html',
  styleUrls: ['./config-projeto-cultura.component.scss'],
})
export class ConfigProjetoCulturaComponent implements OnInit {
  @ViewChild('Modal', { static: false })
  modal: UiModalComponent
  @Output() finalizarSave: EventEmitter<any> = new EventEmitter()
  projetos: Safra[] = []
  projetoPadraoId: number;
  culturaId: number
  anoSafraId: number
  fazendaId: number

  isSubmit: boolean = false
  carregando: boolean = false

  constructor(
    private utils: UtilsService,
    private safraService: SafraService
  ) {}

  ngOnInit() {}

  abrirModal(anoSafraId: number, culturaId: number, fazendaId: number): void {
    this.culturaId = culturaId;
    this.anoSafraId = anoSafraId;
    this.fazendaId = fazendaId;
    this.projetoPadraoId = null;

    this.listarProjetos();
    this.modal.show();
  }

  fecharModal(): void {
    this.modal.hide()
    this.isSubmit = false
  }

  isCampoInvalido(campo: NgModel): boolean {
    return !campo.valid && (campo.dirty || campo.touched || this.isSubmit)
  }

  listarProjetos(): void{
    this.safraService.listarProjetos(this.anoSafraId, this.culturaId).subscribe(
      (res: Safra[]) => {
        this.projetos = res;
        console.debug('Projetos', this.projetos)
        var projetoPadrao = this.projetos.find(p => p.Padrao);
        console.debug('projetoPadrao', projetoPadrao)
        if(projetoPadrao != null)
          this.projetoPadraoId = projetoPadrao.Id;
      },
      (err) => {
        this.utils.getErro(err)
      }
    )
  }

  save(form: NgForm): void {
    this.carregando = true

    if (!this.validarForm(form)) return

    this.safraService.marcarProjetoPadrao(this.projetoPadraoId, this.anoSafraId, this.culturaId, this.fazendaId).subscribe(
      res => {
        this.finalizarSaveRequestSuccess('Projeto padrão alterado com sucesso!')
      },
      err => {
        this.finalizarRequestError(err)
  }
    )

  }

  validarForm(form: NgForm): boolean {
    if (form.invalid) {
      this.isSubmit = true
      this.carregando = false
      this.utils.handleWarning(
        'Por favor, preencha todos os campos obrigatórios corretamente.',
      )
      return false
    }

    return true
  }

  finalizarSaveRequestSuccess(msg: string): void {
    this.utils.handleSuccess(msg)
    this.carregando = false
    this.finalizarSave.emit()
    this.fecharModal()
  }

  finalizarRequestError(error: any): void{
    this.utils.getErro(error)
    this.carregando = false
  }
}
